<div class="dialogHeader">
  <div>
    <h2 mat-dialog-title>AI-наполнение</h2>
    <p>{{ data.productName }}</p>
  </div>
  <button mat-icon-button mat-dialog-close aria-label="Закрыть"><mat-icon>close</mat-icon></button>
</div>

<mat-dialog-content>
  <div class="loading" *ngIf="loading">
    <mat-spinner diameter="34"></mat-spinner>
    <div>
      <b>AI собирает информацию</b>
      <span>Проверяем поставщиков, TecDoc и интернет. Запуск №{{ run?.id || '…' }}</span>
    </div>
  </div>

  <div class="error" *ngIf="error">{{ error }}</div>

  <ng-container *ngIf="!loading && candidates.length">
    <div class="tableActions">
      <mat-checkbox
        [checked]="selectedCount === candidates.length"
        [indeterminate]="selectedCount > 0 && selectedCount < candidates.length"
        (change)="toggleAll($event.checked)"
      >Выбрать все</mat-checkbox>
      <span>{{ candidates.length }} предложений</span>
    </div>

    <div class="proposalTable">
      <div class="proposalRow proposalHead">
        <span></span><span>Поле</span><span>Сейчас</span><span>Предлагается</span><span>Точность</span>
      </div>
      <div class="proposalRow" *ngFor="let item of candidates">
        <mat-checkbox [(ngModel)]="item.selected"></mat-checkbox>
        <b>{{ item.field }}</b>
        <span class="oldValue">{{ item.oldValue || '—' }}</span>
        <mat-icon class="arrow">arrow_forward</mat-icon>
        <span class="newValue">{{ item.proposedValue }}</span>
        <span class="confidence" [class.warning]="item.risk !== 'GREEN'">
          {{ item.confidence | percent: '1.0-0' }}
        </span>
        <small>{{ item.reason }}</small>
      </div>
    </div>
  </ng-container>

  <div class="empty" *ngIf="!loading && !candidates.length && !error">
    AI не нашёл новых данных для этого товара.
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Закрыть</button>
  <button mat-flat-button color="primary" [disabled]="!selectedCount || applying" (click)="apply()">
    <mat-spinner *ngIf="applying" diameter="18"></mat-spinner>
    {{ applying ? 'Применяем…' : 'Применить выбранные (' + selectedCount + ')' }}
  </button>
</mat-dialog-actions>
